import Swal from "sweetalert2";

export default {
  namespaced: true,
  state: {
    programs: {
      loading: false,
      data: [],
    },
    program: null,
    programLoading: false,
    createProgramLoading: false,
    updateProgramLoading: false,
    deleteProgramLoading: null,
  },
  mutations: {
    SET_PROGRAMS_LOADING: function (state, payload) {
      state.programs.loading = payload;
    },
    SET_PROGRAMS_DATA: function (state, payload) {
      state.programs.data = payload;
    },
    SET_PROGRAM: function (state, payload) {
      state.program = payload;
    },
    SET_PROGRAM_LOADING: function (state, payload) {
      state.programLoading = payload;
    },
    SET_CREATE_PROGRAM_LOADING: function (state, payload) {
      state.createProgramLoading = payload;
    },
    SET_UPDATE_PROGRAM_LOADING: function (state, payload) {
      state.updateProgramLoading = payload;
    },
    SET_DELETE_PROGRAM_LOADING: function (state, payload) {
      state.deleteProgramLoading = payload;
    },
  },
  actions: {
    getPrograms: function ({ commit }, payload) {
      const vm = this;
      commit("SET_PROGRAMS_LOADING", true);
      const filters = [];
      if (payload) {
        if (payload.search) {
          filters.push(`search=${payload.search}`);
        }
        if (payload.serviceId) {
          filters.push(`service_id=${payload.serviceId}`);
        }
        if (payload.status) {
          filters.push(`status=${payload.status}`);
        }
      }
      let url = `programs`;
      if (filters.length) {
        url += `?${filters.join("&")}`;
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_PROGRAMS_DATA", res.data.data);
            commit("SET_PROGRAMS_LOADING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_PROGRAMS_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getProgram: function ({ commit }, programId) {
      const vm = this;
      commit("SET_PROGRAM_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.get(`programs/${programId}`).then(
          (res) => {
            commit("SET_PROGRAM", res.data.data);
            commit("SET_PROGRAM_LOADING", false);
            resolve(res.data?.data);
          },
          (err) => {
            commit("SET_PROGRAM_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    create: function ({ commit }, payload) {
      const vm = this;
      commit("SET_CREATE_PROGRAM_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.post(`programs`, payload).then(
          (res) => {
            commit("SET_CREATE_PROGRAM_LOADING", false);
            resolve(res.data?.data);
          },
          (err) => {
            commit("SET_CREATE_PROGRAM_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    update: function ({ commit }, payload) {
      const vm = this;
      commit("SET_UPDATE_PROGRAM_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.put(`programs/${payload.id}`, payload).then(
          (res) => {
            commit("SET_UPDATE_PROGRAM_LOADING", false);
            resolve(res.data?.data);
          },
          (err) => {
            commit("SET_UPDATE_PROGRAM_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    delete: function ({ commit }, programId) {
      const vm = this;
      commit("SET_DELETE_PROGRAM_LOADING", programId);
      return new Promise((resolve) => {
        return vm.$http.delete(`programs/${programId}`).then(
          () => {
            commit("SET_DELETE_PROGRAM_LOADING", null);
            resolve(true);
          },
          (err) => {
            commit("SET_DELETE_PROGRAM_LOADING", null);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getBasicPrograms: function () {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.get(`basic-programs`).then(
          (res) => {
            resolve(res.data?.data);
          },
          (err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve([]);
          }
        );
      });
    },
  },
};
